import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { RecordAction } from "../../../../utils/enums/shared/enums";

export interface AutoCompleteModel {
    value: any;
    display: string;
}

@Component({
    selector: "app-tag-input",
    templateUrl: "./tag-input.component.html",
    styleUrls: ["./tag-input.component.scss"],
})
export class TagInputComponent implements OnInit {
    @Input("roles") roles: any;
    @Input("userRoles") userRoles: any;
    // @Input("roles") rolesBackUp: any;

    @Input() actionInput: RecordAction;
    @Input() maxItems: number = 5;
    items: any = [];
    roleChip: any;
    placeholder: string = "Select Roles";
    @Output() tagAddItem = new EventEmitter();
    @Output() tagDeleteItem = new EventEmitter();

    constructor(private translateService: TranslateService) {
        this.translateService.setDefaultLang("en");
        this.translateService.use(localStorage.getItem("language") || "en");
    }

    ngOnInit() {
        if (this.actionInput === RecordAction.Update) {
            for (let rol of this.userRoles) {
                this.items.push({ display: rol.name, value: rol.roleId });
            }
        }
    }

    onAdd(item: any) {
        this.tagAddItem.emit(item);
    }

    onRemove(item: any) {
        this.tagDeleteItem.emit(item);
    }
}
